/**
 * Practice Settings Page
 *
 * Page for managing organization settings including patient visibility
 * and templates configuration.
 * Part of the "Your Practice" feature.
 */

import { Box, Typography } from '@mui/material';

import { OrganizationInfoCards } from './components/OrganizationInfoCards';
import { OrganizationPageWrapper } from './components/OrganizationPageWrapper';
import { PatientVisibilitySection } from './components/PatientVisibilitySection';
import { ReadOnlyTemplatesSection } from './components/ReadOnlyTemplatesSection';
import { useOrganizationAccess } from './store';

export default function PracticeSettingsPage() {
  const { organizationData } = useOrganizationAccess();

  return (
    <OrganizationPageWrapper pageTitle="Practice Settings">
      {/* Organization Info */}
      <OrganizationInfoCards
        organization={organizationData}
        activeMembers={[]}
        inactiveMembers={[]}
        variant="info"
      />

      {/* Patient Visibility Settings */}
      <Box sx={{ mb: 3 }}>
        <PatientVisibilitySection />
      </Box>

      {/* Resources Section */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
          Resources
        </Typography>
        <ReadOnlyTemplatesSection />
      </Box>
    </OrganizationPageWrapper>
  );
}
